import { render, staticRenderFns } from "./AccessSuspensionOverlay.vue?vue&type=template&id=198e765d&scoped=true&"
import script from "./AccessSuspensionOverlay.vue?vue&type=script&lang=js&"
export * from "./AccessSuspensionOverlay.vue?vue&type=script&lang=js&"
import style0 from "./AccessSuspensionOverlay.vue?vue&type=style&index=0&id=198e765d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198e765d",
  null
  
)

export default component.exports